"use strict";

var app = {

	settings: {},

	vars: {},

	init: function init() {
		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));

		$.fancybox.defaults.clickContent = false;
		$.fancybox.defaults.animationEffect = "fade";
		$.fancybox.defaults.loop = true;
		$.fancybox.defaults.infobar = false;
		$.fancybox.defaults.protect = false;
		$.fancybox.defaults.buttons = ["close"];
		$.fancybox.defaults.lang = "de", $.fancybox.defaults.i18n = {
			de: {
				CLOSE: "Schliessen",
				NEXT: "Weiter",
				PREV: "Zurück",
				ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
				PLAY_START: "Diaschau starten",
				PLAY_STOP: "Diaschau beenden",
				FULL_SCREEN: "Vollbild",
				THUMBS: "Vorschaubilder",
				DOWNLOAD: "Herunterladen",
				SHARE: "Teilen",
				ZOOM: "Maßstab"
			}
		};

		$.fancybox.defaults.onInit = function () {
			$('.fancybox-inner > .fancybox-navigation').remove();
			$('.fancybox-inner > .fancybox-toolbar').remove();
			$('<div class="fancybox-toolbar"><button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Schliessen"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg></button></div>').appendTo('.fancybox-slide--image > div');
			$('<div class="fancybox-navigation"><button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Zurück"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></div></button><button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Weiter"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></div></button></div>').appendTo('.fancybox-slide--image > div');
		};
		$.fancybox.defaults.beforeShow = function () {
			if ($('.fancybox-slide--current > div .fancybox-navigation').length < 1) {
				$('<div class="fancybox-toolbar"><button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Schliessen"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg></button></div>').appendTo('.fancybox-slide--image > div');
				$('<div class="fancybox-navigation"><button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Zurück"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></div></button><button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Weiter"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></div></button></div>').appendTo('.fancybox-slide--image > div');
			}
		};
		$.fancybox.defaults.afterShow = function (e) {
			if ($('.fancybox-slide--current > div .fancybox-navigation').length < 1) {
				$('<div class="fancybox-toolbar"><button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Schliessen"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg></button></div>').appendTo('.fancybox-slide--image > div');
				$('<div class="fancybox-navigation"><button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Zurück"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></div></button><button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Weiter"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></div></button></div>').appendTo('.fancybox-slide--image > div');
			}

			var ex = e;

			if (!$(ex.$trigger).hasClass('force-fancybox--nobottom')) {
				if ($('.fancybox-slide--current > div .fancybox-socialmedia').length < 1) {
					var ImgPath = $('.fancybox-slide--current .fancybox-image').attr('src');
					var $fancybox_sm = $('<div class="fancybox-socialmedia"></div>');
					$fancybox_sm.html('<iframe src="//www.facebook.com/plugins/like.php?href=http%3A%2F%2F' + ImgPath + '&amp;send=false&amp;layout=button_count&amp;width=250&amp;show_faces=false&amp;action=like&amp;colorscheme=light&amp;font=arial&amp;height=21&amp;appId=124763440876220" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:120px; height:21px;" allowTransparency="true"></iframe>&nbsp;<a href="http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(document.URL) + '&media=http%3A%2F%2F' + ImgPath + '&description=' + encodeURIComponent(document.title) + '" class="pin-it-button" count-layout="horizontal"><img border="0" src="//assets.pinterest.com/images/PinExt.png" title="Pin It" /></a>');
					$fancybox_sm.appendTo('.fancybox-slide--current > div');
				}
			} else {
				$('.fancybox-slide--current > div .fancybox-socialmedia').remove();
				$('.fancybox-slide--current').addClass('noborder');
			}
		};
	},

	parse: function parse($context) {
		this.initLocalExtensions($context);
	},

	initGlobalExtensions: function initGlobalExtensions() {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!app.obj[globalExt]) {
				app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function initLocalExtensions($context) {
		var t = this;
		for (var ext in t.ext) {
			var $els = $context.findOrSelf('.js-' + ext);
			$els.each(function () {
				var fn = new t.ext[ext]($(this));

				$(this).data('obj_' + ext, fn);

				if (app.obj[ext] === undefined) app.obj[ext] = [];
				if ($(this).data('objectName')) {
					app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					app.obj[ext].push(fn);
				}
			});
		}
	},

	ext: {},
	globalExt: {},
	obj: {}
};

$(function () {
	app.init();
});

$.fn.findOrSelf = function (selector) {
	return this.find(selector).add(this.filter(selector));
};

function clearValidity(myid) {
	document.getElementById(myid).setCustomValidity('');
}
app.globalExt['global-structure'] = function () {
	var api = {};

	var init = function init() {};

	init();return api;
};

app.ext['accordion'] = function ($el) {
	var api = {};

	var classes = {
		item: '.js-accordion-item',
		itemQuestion: '.js-accordion-item-question',
		itemAnswer: '.js-accordion-item-answer',
		simpleAccordion: '.js-accordion-trigger',
		content: '.js-accordion-content'
	};

	var states = {
		isActive: 'is-active',
		clsOpen: 'open'
	};

	var clicked = false;

	var $questions = $el.find(classes.itemQuestion);

	var init = function init() {
		addListeners();
	};

	var addListeners = function addListeners() {
		$questions.on('click', onQuestionClickHandler);
		accordionEvent();
	};

	var onQuestionClickHandler = function onQuestionClickHandler(e) {
		e.preventDefault();
		var $item = $(this).closest(classes.item);
		var $answer = $item.find(classes.itemAnswer);

		if ($item.hasClass(states.isActive)) {
			$item.removeClass(states.isActive);
			$answer.slideUp(300);
		} else {
			$item.addClass(states.isActive);
			$answer.slideDown(300);
		}
	};

	var accordionEvent = function accordionEvent(e) {
		if (clicked === false) {
			$(classes.simpleAccordion).on('click', function (e) {
				clicked = true;
				if ($(classes.content).hasClass(states.clsOpen)) {
					$(classes.content).slideUp(200, function () {
						clicked = false;
					});
					$(classes.content).removeClass(states.clsOpen);
				} else {
					$(classes.content).slideDown(200, function () {
						clicked = false;
					});
					$(classes.content).addClass(states.clsOpen);
				}
			});
		}
	};

	init();return api;
};
app.ext['cookiebar'] = function ($el) {
	var api = {};

	var classes = {
		accept: '.js-cookiebar-accept'
	};

	var states = {
		isHidden: 'is-hidden'
	};

	var $accept = $el.find(classes.accept);

	var init = function init() {
		addListeners();
		checkCookieStatus();
	};

	var addListeners = function addListeners(e) {
		$accept.on('click', onAcceptClickHandler);
	};

	var onAcceptClickHandler = function onAcceptClickHandler(e) {
		e.preventDefault();
		acceptCookies();
	};

	var hide = function hide() {
		$el.addClass(states.isHidden);
	};

	var show = function show() {
		$el.removeClass(states.isHidden);
	};

	var acceptCookies = function acceptCookies() {
		Cookies.set('gdpr_cookies', 'accepted', { expires: 365, path: '/' });
		hide();
	};

	var checkCookieStatus = function checkCookieStatus() {
		if (Cookies.get('gdpr_cookies') != 'accepted') {
			show();
		}
	};

	init();return api;
};

app.ext['form'] = function ($element) {
	var api = {};
	var $message = $('.js-form-message');

	var init = function init() {
		formSubmitAction();
	};

	/**
  * event for form submit
  * @return {[type]} [description]
  */
	var formSubmitAction = function formSubmitAction() {
		$element.on('submit', function (e) {
			var url = $element.attr('action');
			var method = $element.attr('method');

			// general info
			var info = {
				form: $element.attr('name'),
				url: window.location.href
			};

			var form = new FormData($element[0]);
			form.append('test', 'test text');
			form.append('referer', window.location.href);
			// complete data
			var data = form + '&' + $.param(info);

			// ajax request
			$.ajax({
				method: method,
				url: url,
				data: form,
				contentType: false,
				processData: false
			}).done(function (msg) {
				if (msg.code === 200) {

					changeMessage(msg.message);
					$element[0].reset();
				} else {
					changeMessage(msg.message, true);
				}
			}).fail(function (msg) {
				changeMessage('Error', true);
			});

			e.preventDefault();
		});
	};

	var cleanMessage = function cleanMessage() {
		$message.html('');
		$message.removeClass('is-error is-success');
	};

	var changeMessage = function changeMessage(text) {
		var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


		cleanMessage();
		$message.html(text);

		if ($('.js-360-form').length > 0) $('.js-360-form').remove();
		if ($('.js-unsubscribe-wrap').length > 0) $('.js-unsubscribe-wrap form').remove();

		if ($('.js-contact-default').length > 0) {
			$('.js-contact-default form').remove();
			$('.js-contact-default').next('.mandatory_fields').remove();
		}

		if ($('.js-catalogue-form').length > 0) {
			$('.js-catalogue-form form').remove();
			$('.js-catalogue-form').next('.mandatory_fields').remove();
		}

		if ($('.js-propertydetail-form').length > 0) {
			$('.js-propertydetail-form form').remove();
			$('.js-propertydetail-form').next('.mandatory_fields').remove();
			$('.js-propertydetail-form').prev('p').remove();
		}

		if (error) {
			$message.addClass('is-error');
		} else {
			$message.addClass('is-success');
		}
	};

	init();
	return api;
};

app.ext['gallery'] = function ($el) {
	var api = {};

	var classes = {
		mainGallery: '.js-gallery-main',
		thumbnailGallery: '.js-gallery-thumbnails'
	};

	var states = {
		isActive: 'is-active'
	};

	var slidesPerView = $el.attr('data-slides-per-view');

	var $mainGallery = $el.find(classes.mainGallery);
	var $mainGalleryInstance;

	var $thumbnailGallery = $el.find(classes.thumbnailGallery);
	var $thumbnailGalleryInstance;

	var init = function init() {
		addListeners();
		initSlider();
	};

	var addListeners = function addListeners() {
		$thumbnailGallery.on('click', 'img', onThumbnailsControlsClick);
	};

	var initSlider = function initSlider() {

		$mainGalleryInstance = new Swiper($mainGallery[0], {
			spaceBetween: 10,
			autoplay: {
				delay: 5000
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets'
			}
		});

		$thumbnailGalleryInstance = new Swiper($thumbnailGallery[0], {
			spaceBetween: 10,
			slidesPerView: slidesPerView
		});

		$mainGalleryInstance.on('slideChangeTransitionStart', function () {

			var index = $mainGalleryInstance.realIndex;
			var groupindex = Math.floor((index + 1) / slidesPerView) * slidesPerView;

			$thumbnailGalleryInstance.slides.each(function () {
				$(this).removeClass(states.isActive);
			});

			$($thumbnailGalleryInstance.slides[index]).addClass(states.isActive);

			$thumbnailGalleryInstance.slideTo(groupindex, 300, false);
		});
	};

	var onThumbnailsControlsClick = function onThumbnailsControlsClick() {
		var index = $(this).parent().index();
		$mainGalleryInstance.slideTo(index, 300, true);
		$mainGalleryInstance.autoplay.stop();
	};

	init();return api;
};

app.ext['header'] = function ($el) {
	var api = {};

	var classes = {
		triggerMenu: '.js-header-trigger-menu',
		triggerSearch: '.js-header-trigger-search',
		menu: '.js-header-menu',
		search: '.js-header-search'
	};

	var states = {
		isActive: 'is-active'
	};

	var $menu = $el.find(classes.menu);
	var $search = $el.find(classes.search);
	var $triggerMenu = $el.find(classes.triggerMenu);
	var $triggerSearch = $el.find(classes.triggerSearch);

	var init = function init() {
		addListeners();
	};

	var addListeners = function addListeners() {
		$triggerMenu.on('click', onTriggerMenuClickHandler);
		$triggerSearch.on('click', onTriggerSearchClickHandler);
	};

	var onTriggerMenuClickHandler = function onTriggerMenuClickHandler(e) {
		e.preventDefault();

		if ($menu.hasClass(states.isActive)) {
			unfixBackground();
			$menu.removeClass(states.isActive);
		} else {
			$search.removeClass(states.isActive);
			$menu.addClass(states.isActive);
			setTimeout(fixBackground, 270);
		}
	};

	var onTriggerSearchClickHandler = function onTriggerSearchClickHandler(e) {
		e.preventDefault();

		if ($search.hasClass(states.isActive)) {
			unfixBackground();
			$search.removeClass(states.isActive);
		} else {
			$menu.removeClass(states.isActive);
			$search.addClass(states.isActive);
			setTimeout(fixBackground, 270);
		}
	};

	var fixBackground = function fixBackground(e) {

		$('.js-site .container').css({
			position: 'fixed',
			'z-index': '-1'
		});
	};

	var unfixBackground = function unfixBackground(e) {

		$('.js-site .container').attr('style', '');
	};

	init();return api;
};

app.ext['infos'] = function ($element) {
	var api = {};
	var popup = null;
	var deactivate_event = false;

	var init = function init() {
		var videos = document.querySelectorAll('.js-video');
		for (var i = 0; i < videos.length; i++) {
			if (!$(videos[i]).hasClass('js-prevent-event')) {
				$(videos[i]).addClass('js-prevent-event');
				attachEvent(videos[i]);
			}
		}

		videos = document.querySelectorAll('.js-video-secondary');
		for (var _i = 0; _i < videos.length; _i++) {
			if (!$(videos[_i]).hasClass('js-prevent-event')) {
				$(videos[_i]).addClass('js-prevent-event');
				attachEvent(videos[_i]);
			}
		}
	};

	/**
  * attach action to video element click
  * @param  {[type]} el [description]
  * @return {[type]}    [description]
  */
	var attachEvent = function attachEvent(el) {
		el.addEventListener('click', function (e) {
			createPopup(createYoutubeContent(el.dataset.video));
			e.preventDefault();
			e.stopPropagation();
		});
	};

	/**
  * create youtube embed iframe with all parameters
  * @param  {[type]} videoId youtube video id
  * @return {[type]}         [description]
  */
	var createYoutubeContent = function createYoutubeContent(videoId) {
		if (!videoId) return false;

		var content = "<div class='video__wrapper'><iframe id=\"ytplayer\" type=\"text/html\" width=\"640\" height=\"360\"\n\t\t\t\t\t\tsrc=\"https://www.youtube.com/embed/" + videoId + "?autoplay=1\"\n\t\t\t\t\t\tframeborder=\"0\"></iframe></div>";

		return content;
	};

	/**
  * create popup with content
  * @param  {[type]} content html of the inside popip
  */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}

		var addClass = '';
		if (content.indexOf('video__wrapper') > -1) addClass = 'popup__inner--video';

		popup.innerHTML = "<div class='popup__inner " + addClass + ("'>" + content + "<button class='popup__close'></button></div>");
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;
		}
	};

	init();
	return api;
};

app.ext['local-structure'] = function ($el) {
	var api = {};

	var init = function init() {};

	init();return api;
};

app.ext['mobiletap'] = function ($element) {
	var api = {};

	var classes = {
		item: '.js-mobiletap'
	};

	var init = function init() {
		addListeners();
	};

	/**
 * attach action to video element click
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
	var addListeners = function addListeners(el) {
		$(classes.item).on('click', onTapHandler);
	};

	var onTapHandler = function onTapHandler(e) {

		var ww = Number($(window).innerWidth());

		if (ww < 769 && $(e.target).parents('li').find('ul').length > 0 && !$(e.target).parents('li').find('ul').is(':visible')) {
			e.preventDefault();

			$(e.target).closest('div').find('.is-active-arrow').removeClass('is-active-arrow');
			$(e.target).closest('div').find('ul ul').hide(0);

			$(e.target).parents('li').addClass('is-active-arrow');
			$(e.target).parents('li').find('ul').show(0);
		}
	};

	init();
	return api;
};

app.ext['overlay'] = function ($element) {
	var api = {};
	var popup = null;

	var init = function init() {
		attachEvent($element[0]);
	};

	/**
 * attach action to video element click
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
	var attachEvent = function attachEvent(el) {
		el.addEventListener('click', function (e) {
			createPopup(createPopupContent(el.href));
			e.preventDefault();
			e.stopPropagation();
		});
	};

	/**
 * create iframe
 * @param  {[type]} url url of the page
 * @return {[type]}         [description]
 */
	var createPopupContent = function createPopupContent(url) {
		if (!url) return false;
		var content = "<iframe id=\"overlay\" type=\"text/html\" src=\"" + url + "\" width=\"769\" frameborder=\"0\" height=\"650px\"></iframe>";

		return content;
	};

	/**
 * create popup with content
 * @param  {[type]} content html of the inside popip
 */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}
		popup.innerHTML = "<div class='popup__inner'>" + content + "<button class='popup__close'></button></div>";
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;

			removeIframeStyles();
		}
	};

	init();
	return api;
};

function setIframeHeight(h) {

	if ($('.js-site').parent('.js-wrap').length < 1) {

		var scrollpos = document.documentElement.scrollTop;

		$('.js-site').wrap('<div class="js-wrap"></div>');
		$('.js-site').css({
			'margin-top': '-' + scrollpos + 'px'
		});

		window.scrollTo(0, 0);

		h += 10;
		var bg_h = h + 240;

		if ($('.popup__inner--full').length < 1) {

			if ($('#popup').length) {
				$('#popup iframe').css({
					height: h + 'px',
					maxHeight: 'none'
				}).attr('scrolling', 'no');
				$('.popup').css({
					position: 'absolute',
					height: bg_h + 'px'
				});

				var top = '100px';
				if ($('body').hasClass('page__property-360')) top = '40px';

				$('.popup__inner').css({
					height: 'auto',
					maxHeight: 'none',
					top: top,
					transform: 'translate(-50%, 0px)',
					'margin-bottom': '100px'
				});
			}
		}
	}
}

function removeIframeStyles() {

	var oldscrollpos = $('.js-site').css('margin-top');
	oldscrollpos = oldscrollpos.replace('px', '');
	oldscrollpos = oldscrollpos.replace('-', '');
	$('.js-wrap').removeClass('js-wrap');
	$('.js-site').css('margin-top', '0px');
	window.scrollTo(0, oldscrollpos);
}
app.ext['photo'] = function ($element) {
	var api = {};
	var popup = null;
	var gallery = [];
	var curentPosition = 0;

	var init = function init() {
		if (window.innerWidth < 1025) {
			return false;
		}

		attachEvent($element);
	};

	/**
 * attach action to video element click
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
	var attachEvent = function attachEvent($el) {
		$el.on('click', function (e) {
			gallery = createGalleryList(this);
			curentPosition = getPositionInGallery(gallery, this);
			createPopup(createPopupContent(gallery[curentPosition]));
			e.preventDefault();
			e.stopPropagation();
		});
	};

	/**
  * create list of images for popup
  * @type {[type]}
  */
	var createGalleryList = function createGalleryList(el) {
		var group = el.dataset.gallery;
		var galleryList = [];

		if (!group) {
			galleryList = [el.dataset.src];
			return galleryList;
		}

		var imageElems = document.querySelectorAll('[data-gallery="' + group + '"]');
		for (var i = 0; i < imageElems.length; i++) {
			galleryList.push(imageElems[i].dataset.src);
		}

		return galleryList;
	};

	/**
  * get position of the element in gallery
  * @param  {[type]} gallery [description]
  * @param  {[type]} element [description]
  * @return {[type]}         [description]
  */
	var getPositionInGallery = function getPositionInGallery(gallery, element) {
		for (var i = 0; i < gallery.length; i++) {
			if (gallery[i] === element.dataset.src) return i;
		}
		return -1;
	};

	/**
 * create iframe
 * @param  {[type]} url url of the page
 * @return {[type]}         [description]
 */
	var createPopupContent = function createPopupContent(url) {
		if (!url) return false;
		var content = "<img src=\"" + url + "\" id=\"popupImage\" class=\"popup-image\">";

		return content;
	};

	/**
 * create popup with content
 * @param  {[type]} content html of the inside popip
 */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}

		var innerPopup = document.createElement('div');
		innerPopup.classList.add('popup__inner');
		innerPopup.classList.add('popup__inner--autosize');
		innerPopup.innerHTML = content + "<button class='popup__close'></button>";
		popup.appendChild(innerPopup);

		// add buttons prev/next
		if (gallery.length > 1) {
			var btnPrev = document.createElement('button');
			btnPrev.classList.add('popup__btn', 'popup__btn--prev');
			btnPrev.addEventListener('click', function (e) {
				curentPosition = curentPosition > 0 ? curentPosition - 1 : gallery.length - 1;
				switchImage();
				e.preventDefault();
				e.stopPropagation();
				return true;
			});
			innerPopup.appendChild(btnPrev);

			var btnNext = document.createElement('button');
			btnNext.classList.add('popup__btn', 'popup__btn--next');
			btnNext.addEventListener('click', function (e) {
				curentPosition = curentPosition < gallery.length - 1 ? curentPosition + 1 : 0;
				switchImage();
				e.preventDefault();
				e.stopPropagation();
				return true;
			});
			innerPopup.appendChild(btnNext);
		}
	};

	/**
  * change url of the image element to the new position
  * @return {[type]} [description]
  */
	var switchImage = function switchImage() {
		var img = document.getElementById('popupImage');
		img.src = gallery[curentPosition];
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;
		}
	};

	init();
	return api;
};

app.ext['popup-iframe'] = function ($element) {
	var api = {};
	var popup = null;

	var init = function init() {
		attachEvent($element[0]);
	};

	/**
 * attach action to video element click
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
	var attachEvent = function attachEvent(el) {
		el.addEventListener('click', function (e) {
			createPopup(createPopupContent(el.dataset.href));
			e.preventDefault();
			e.stopPropagation();
		});
	};

	/**
 * create iframe
 * @param  {[type]} url url of the page
 * @return {[type]}         [description]
 */
	var createPopupContent = function createPopupContent(url) {
		if (!url) return false;
		var content = "<iframe id=\"iframe\" type=\"text/html\" src=\"" + url + "\" frameborder=\"0\"></iframe>";

		return content;
	};

	/**
 * create popup with content
 * @param  {[type]} content html of the inside popip
 */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}
		popup.innerHTML = "<div class='popup__inner popup__inner--full'>" + content + "<button class='popup__close'></button></div>";
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;

			removeIframeStyles();
		}
	};

	init();
	return api;
};

app.ext['properties-col'] = function ($element) {
	var api = {};
	console.log('xxxxx');
	var init = function init() {
		console.log('xxxxx 2');
		$element.find('button').on('click', function () {
			var that = $(this);
			that.find('span').each(function (i, el) {
				$(el).slideToggle(300);
			});

			$element.find('.js-properties-col-main').slideToggle(300).toggleClass('is-active');

			if ($element.parent().find('.js-properties-col-main.is-active').length > 0) {
				$element.parent().addClass('opened');
			} else {
				setTimeout(function () {
					$element.parent().removeClass('opened');
				}, 300);
			}
		});
	};

	init();
	return api;
};

app.ext['property-form'] = function ($element) {
	var api = {};
	var popup = null;
	var triggered = false;

	var init = function init() {
		attachEvent($element[0]);
	};

	/**
 * attach action to video element click
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
	var attachEvent = function attachEvent(el) {
		el.addEventListener('click', function (e) {
			triggered = true;
			createPopup(createPopupContent(el.dataset.href));
			e.preventDefault();
			e.stopPropagation();
		});

		setTimeout(function () {
			if ($('.js-property-trigger').length > 0 && triggered == false) {
				$('.js-property-trigger').click();
			}
		}, 15000);
	};

	/**
 * create iframe
 * @param  {[type]} url url of the page
 * @return {[type]}         [description]
 */
	var createPopupContent = function createPopupContent(url) {
		if (!url) return false;
		var content = "<iframe id=\"send-plan\" type=\"text/html\" src=\"" + url + "\" width=\"810\" frameborder=\"0\" height=\"850px\"></iframe>";

		return content;
	};

	/**
 * create popup with content
 * @param  {[type]} content html of the inside popip
 */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}
		popup.innerHTML = "<div class='popup__inner popup__inner--small'>" + content + "<button class='popup__close'></button></div>";
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;
		}
	};

	init();
	return api;
};

app.ext['property'] = function ($el) {
	var api = {};

	var classes = {
		detailsTrigger: '.js-property-details-trigger',
		detailsContainer: '.js-property-details-container',
		meta: '.js-property-meta'
	};

	var duration = 300;

	var $detailsTrigger = $el.find(classes.detailsTrigger);
	var $detailsContainers = $el.find(classes.detailsContainer);
	var $meta = $el.find(classes.meta);

	var init = function init() {
		addListeners();
	};

	var addListeners = function addListeners() {
		$detailsTrigger.on('click', function (e) {
			console.log(this);

			if ($(this).find('.js-show-default').length > 0) {
				if ($(this).find('.js-show-default').hasClass('ishidden')) {
					$(this).find('.js-show-default').removeClass('ishidden');
					$(this).find('.js-show-open').addClass('ishidden');
				} else {
					$(this).find('.js-show-default').addClass('ishidden');
					$(this).find('.js-show-open').removeClass('ishidden');
				}
			}

			var formName = this.dataset.form;
			toggleForm(formName);
			scroll($("#formSection"));
		});
	};

	var toggleForm = function toggleForm(formName) {
		var duration = 300;
		$detailsContainers.each(function (index, item) {

			var $item = $(item);

			if (item.dataset.form == formName) {
				// item.classList.toggle(className);
				$item.slideToggle(duration);
			} else {
				// item.classList.remove(className);
				$item.slideUp(duration);
			}
		});
	};

	var scroll = function scroll($el) {
		$('html, body').animate({
			scrollTop: $el.offset().top
		}, duration);
	};

	init();return api;
};

app.ext['select-url'] = function ($element) {
	var api = {};

	var init = function init() {
		attachEvent();

		$('.js-regions-link').on('click', function () {
			$(this).parents('.regions-content__regions').find('.js-regions-link').removeClass('active');
			$(this).addClass('active');
		});

		if (window.location.hash.length > 3) {
			$('.js-regions-link[href="' + window.location.hash + '"]').addClass('active');
		}
	};

	var attachEvent = function attachEvent() {

		var type = $element.data('type');

		$element.on('change', function (e) {

			switch (type) {
				case 'url':
					window.location.href = e.target.value;
					break;

				case 'hash':
					window.location.hash = e.target.value;
					break;
			}
		});
	};

	init();
	return api;
};

app.ext['stickykit'] = function ($el) {
	var api = {};

	var init = function init() {
		if ($(window).width() > 768) {
			$el.stick_in_parent();
		}
	};

	init();return api;
};

app.ext['tabs-mobile'] = function ($element) {
	var api = {};

	var classes = {
		menus: '.js-tabs-item ul'
	};

	var init = function init() {
		attachEvent($element);
	};

	var attachEvent = function attachEvent($el) {
		$el.on('click', function (e) {

			if (!$el.parent().find('ul').is(':visible')) {
				$('.js-tabs-mobile.is-active').removeClass('is-active');
				$(classes.menus).slideUp(250);
				$el.addClass('is-active');
				$el.parent().find('ul').slideDown(250);
			}

			e.preventDefault();
		});
	};

	init();
	return api;
};

app.ext['tabs'] = function ($el) {
	var api = {};

	var classes = {
		header: '.js-tabs-header',
		content: '.js-tabs-content',
		item: '.js-tabs-item',
		headerItem: '.js-tabs-header-item'
	};

	var states = {
		isActive: 'is-active'
	};

	var $header = $el.find(classes.header);
	var $content = $el.find(classes.content);
	var $items = $el.find(classes.item);
	var $headerItems = $el.find(classes.headerItem);

	var init = function init() {
		addMinHeight();
		addListeners();

		setActiveAuto();
	};

	var addMinHeight = function addMinHeight() {
		$content.css('min-height', $content.height());
	};

	var addListeners = function addListeners() {
		$headerItems.on('click', onHeaderItemClickHandler);
	};

	var onHeaderItemClickHandler = function onHeaderItemClickHandler(e) {
		e.preventDefault();

		var item = $(this).attr('data-item');

		$headerItems.removeClass(states.isActive);
		$header.find('[data-item=' + item + ']').addClass(states.isActive);

		$items.removeClass(states.isActive);
		$content.find('[data-item=' + item + ']').addClass(states.isActive);
	};

	/**
  * set activate tab based on li with attribute current
  */
	var setActiveAuto = function setActiveAuto(e) {
		var $current = $('[data-current="true"]');
		if ($current) {
			var $tab = $current.parents('.js-tabs-item');
			var $tabName = $tab.data('item');
			$('.js-tabs-header-item[data-item="' + $tabName + '"]').click();
		}
	};

	init();

	return api;
};

app.ext['video'] = function ($element) {
	var api = {};
	var popup = null;

	var init = function init() {
		attachEvent($element[0]);
	};

	/**
  * attach action to video element click
  * @param  {[type]} el [description]
  * @return {[type]}    [description]
  */
	var attachEvent = function attachEvent(el) {
		el.addEventListener('click', function (e) {
			createPopup(createYoutubeContent(el.dataset.video));

			e.preventDefault();
			e.stopPropagation();
		});
	};

	/**
  * create youtube embed iframe with all parameters
  * @param  {[type]} videoId youtube video id
  * @return {[type]}         [description]
  */
	var createYoutubeContent = function createYoutubeContent(videoId) {
		if (!videoId) return false;

		var content = "<div class='video__wrapper'><iframe id=\"ytplayer\" type=\"text/html\" width=\"640\" height=\"360\"\n\t\t\t\t\t\tsrc=\"https://www.youtube.com/embed/" + videoId + "?autoplay=1\"\n\t\t\t\t\t\tframeborder=\"0\"></iframe></div>";

		return content;
	};

	/**
  * create popup with content
  * @param  {[type]} content html of the inside popip
  */
	var createPopup = function createPopup(content) {
		if (!popup) {
			popup = document.createElement('div');
			popup.id = 'popup';
			popup.classList.add('popup');
			popup.addEventListener('click', closePopup);
			document.body.appendChild(popup);
		}
		popup.innerHTML = "<div class='popup__inner popup__inner--autosize'>" + content + "<button class='popup__close'></button></div>";
	};

	/**
  * remove popup from the dom
  * @return {[type]} [description]
  */
	var closePopup = function closePopup() {
		if (popup) {
			popup.parentNode.removeChild(popup);
			popup = null;
		}
	};

	init();
	return api;
};